/* eslint-disable */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import styles from './Styles';
import AuthService from '../../Services/AuthService';
import Badge from '@material-ui/core/Badge';
import EventList from './EventStatus';


const social = ['GitHub', 'Twitter', 'Facebook'];

class Profile extends Component {

  constructor(props) {
    super(props)
    this.Auth = new AuthService();
    this.state = {
      auth: false,
      lead: '',
      username: '',
      profile: {}
    }
  }

  async componentWillMount() {
    this.state.lead = localStorage.getItem('hasLead');
    if (this.Auth.loggedIn()) {
      this.state.auth = true;
      this.state.username = localStorage.getItem('username')
      if (this.state.lead == 1) {
        this.state.profile = JSON.parse(localStorage.getItem('profile'));
        console.log(this.state.profile);
      } else {
        this.props.history.replace(`/createlead`);
        window.location.reload();
      }
    } else {
      this.props.history.replace(`/signin`);
      window.location.reload();
    }
  }

  render(){
    const { classes } = this.props;
    const { profile } = this.state;
    return (
      <div className={classes.layout}>
        <main>
          <Grid container spacing={40} className={classes.mainGrid}>
            <Grid item xs={12} md={8}>
              <Card className={classes.card}>
                  <div className={classes.cardDetails}>
                    <CardContent>
                      <Typography component="h2" variant="h5">
                        Welcome  {profile.name}
                      </Typography>
                      <Divider />
                      <br />
                      <Typography variant="subtitle1" paragraph>
                        Gender : {profile.gender}
                      </Typography>
                      <Typography variant="subtitle1" paragraph>
                        Date of Birth : {profile.dateOfBirth}
                      </Typography>
                      <Typography variant="subtitle1" paragraph>
                        School Name : {profile.school.name}
                      </Typography>
                      <Typography variant="subtitle1" paragraph>
                        Email : {profile.email}
                      </Typography>
                      <Typography variant="subtitle1" paragraph>
                        Mobile : {profile.mobilePhone}
                      </Typography>
                      <Typography variant="subtitle1" paragraph>
                        Status : {profile.status}
                      </Typography>
                      <Typography variant="subtitle1" paragraph>
                        Number of Campaign Attended : {profile.numOfCampaignsAttended}
                      </Typography>
                      <Typography variant="subtitle1" color="primary">
                      <Button variant="contained" color="primary" className={classes.button} href="/editlead">
                          Edit my Profile
                      </Button>
                      </Typography>
                    </CardContent>
                  </div>
                </Card>
            </Grid>
            <Grid item xs={12} md={4}>
              <Paper elevation={0} className={classes.sidebarAboutBox}>
                  <h2>Registered Events</h2>
                    <EventList/>
              </Paper>
            </Grid>
          </Grid>
        </main>
      </div>
  );
  }
}

Profile.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Profile)


// WEBPACK FOOTER //
// ./src/components/Users/Profile.js